import {
  IsDate,
  IsNumber,
  IsNumberString,
  IsOptional,
  IsString,
  IsBoolean,
} from 'class-validator';
import { BaseDto } from './base.dto';
import { MerchantGroupDto } from './merchantGroup.dto';
import { BusinessEntityDto } from './businessEntity.dto';
import { CurrencyDto } from './currency.dto';

export class MerchantBusinessEntityBankDto extends BaseDto {
  @IsString()
  name: string;

  @IsNumber()
  merchantBusinessEntityId: number;

  @IsNumberString()
  iban: string;

  @IsNumberString()
  swiftbic: string;

  @IsDate()
  @IsOptional()
  createdDate?: Date;

  @IsDate()
  @IsOptional()
  modifiedDate?: Date;

  @IsNumber()
  @IsOptional()
  version?: number;

  @IsString()
  @IsOptional()
  accountNumber?: string;

  @IsString()
  @IsOptional()
  sortCode?: string;

  @IsNumber()
  @IsOptional()
  bankName?: string;

  @IsNumber()
  @IsOptional()
  bankAddress?: string;

  @IsBoolean()
  @IsOptional()
  isFireAccount?: boolean;

  @IsBoolean()
  @IsOptional()
  isWithdrawalAccount?: boolean;

  @IsBoolean()
  @IsOptional()
  isAisAccount?: boolean;

  @IsString()
  @IsOptional()
  aisAccount?: string;

  @IsDate()
  @IsOptional()
  aisAccessDisabledAt?: Date;

  @IsString()
  @IsOptional()
  aisAdditionalData?: any;

  @IsNumber()
  @IsOptional()
  balance?: number;

  @IsNumber()
  @IsOptional()
  fireIcan?: number;

  @IsNumber()
  @IsOptional()
  merchantGroupId?: number;

  @IsNumber()
  @IsOptional()
  currencyId?: number;

  merchantGroup?: MerchantGroupDto;
  merchantBusinessEntity?: BusinessEntityDto;
  currency?: CurrencyDto;
}
